import journal from '@/api/journal'
import { mapGetters } from 'vuex'
import special from '@/api/special'
import section from '@/api/section'
import { settingCountry } from '@/api/setting'
import SiteSearchGroup from '@/components/search-group'
import { statisticArticle } from '@/api/statistic'
import help from '@/utils/help'

const columns = [
  {
    title: '',
    enTitle: 'Volume',
    width: 80,
    dataIndex: 'volumeCode'
  },
  {
    title: '',
    enTitle: 'Issue',
    width: 80,
    dataIndex: 'issueCode'
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 150,
    dataIndex: 'code'
  },
  {
    title: '',
    enTitle: 'DOI',
    width: 200,
    dataIndex: 'doi',
    slot: 'doi'
  },
  {
    title: '',
    enTitle: 'Article Type',
    width: 150,
    dataIndex: 'typeCode',
    slot: 'type'
  },
  {
    title: '',
    enTitle: 'Country / Region',
    width: 150,
    dataIndex: 'countryCode',
    slot: 'country'
  },
  {
    title: '',
    enTitle: 'Assigned Editor',
    width: 150,
    dataIndex: 'assignedEditor'
  },
  {
    title: '',
    enTitle: 'APC',
    width: 100,
    dataIndex: 'totalApc',
    sort: true
  },
  {
    title: '',
    enTitle: 'Special Issue',
    width: 200,
    dataIndex: 'special',
    slot: 'special'
  },
  {
    title: '',
    enTitle: 'Section',
    width: 200,
    dataIndex: 'sectionList',
    slot: 'section'
  },
  {
    title: '',
    enTitle: 'Abstract',
    width: 100,
    dataIndex: 'summaryNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Full Text',
    width: 100,
    dataIndex: 'viewNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'PDF Download',
    width: 150,
    dataIndex: 'downloadNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Citation',
    width: 100,
    dataIndex: 'citeNum',
    sort: true
  },
  {
    title: '',
    enTitle: 'Academic Editor',
    width: 140,
    dataIndex: 'academicEditor'
  },
  {
    title: '',
    enTitle: 'Published Date',
    width: 150,
    dataIndex: 'publishedDate',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Accept Date',
    width: 150,
    dataIndex: 'acceptDate',
    slot: 'date',
    sort: true
  },
  {
    title: '',
    enTitle: 'Online Status',
    width: 120,
    dataIndex: 'status',
    slot: 'status'
  }
]
const ARTICLE_STATUS = {
  PUBLISHED: 'Online',
  UNPUBLISHED: 'Pending Online',
  RETRACTION: 'Retraction'
}
export default {
  components: {
    SiteSearchGroup
  },
  data() {
    return {
      columns,
      ARTICLE_STATUS,
      params: {},
      journalList: [],
      showAdv: false,
      dataSource: [],
      sectionList: [],
      specialList: [],
      countryList: [],
      staticTime: '',
      date: [],
      loading: false,
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      }
    }
  },
  computed: {
    ...mapGetters({
      country: 'getCountry',
      user: 'getUser',
      manuscriptType: 'getManuscriptType'
    })
  },
  // watch: {
  //   journalId: {
  //     handler() {
  //       this.getList()
  //     },
  //     immediate: true
  //   }
  // },
  mounted() {
    this.countrySearch()
    this.getJournalList()
    help.closeAutocomplete()
  },
  methods: {
    async getSection() {
      this.sectionList = await section.getAll({
        journalId: this.params.journalId
      })
    },
    async getSpecial(val) {
      if (!this.params.journalId) {
        return
      }
      this.specialList = await special.getByTitle({
        journalId: this.params.journalId,
        released: true,
        limit: 20,
        title: val
      })
    },
    async countrySearch(val) {
      this.countryList = await settingCountry.getAll({
        keyword: val
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some(item => {
        if (item.id === localStorage.getItem('journalId')) {
          this.params.journalId = item.id
          return true
        }
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
        localStorage.setItem('journalId', this.params.journalId)
      }
      this.getList()
      this.getSection()
      this.getSpecial()
    },
    changeJournal(val) {
      this.getList()
      this.getSection()
      this.getSpecial()
      localStorage.setItem('journalId', val)
    },
    async getList(page = 1) {
      const { publishedTimeStart } = this.params
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
        publishedTimeStart: publishedTimeStart
          ? publishedTimeStart.startOf('d')
          : ''
      })

      const {
        list,
        pageIndex,
        pageSize,
        total
      } = await statisticArticle.getData(data)
      this.dataSource = list

      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    },
    handleDateChange(date) {
      this.params.publishedTimeStart = date[0] ? date[0].startOf('d') : ''
      this.params.publishedTimeEnd = date[1] ? date[1].endOf('d') : ''
      this.getList()
    },
    handleClear() {
      const { journalId } = this.params
      this.params = {
        journalId
      }
      this.date = []
      this.getList()
    },
    async goToWebsite(val, type, journalName) {
      let url = `/journal/${journalName}/`
      switch (type) {
        case 'article':
          url += `${val.volumeCode}/${val.issueCode}/${val.doi}`
          break
        case 'special':
          url += `special_issues/${val.code}`
          break
        case 'section':
          url += `section/${val.name}`
          break
      }
      const { host } = window.location
      if (
        host.includes('192.168.5') ||
        host.includes('192.168.4.34') ||
        host.includes('102.168.4.21') ||
        host.includes('localhost')
      ) {
        url = 'http://192.168.5.18:3020' + url
      } else if (
        host.includes('192.168.4.23') ||
        host.includes('imrpress.tech:9100')
      ) {
        url = 'http://www.imrpress.tech' + url
      } else if (host.includes('imrpress.tech:8100')) {
        url = 'http://www.imrpress.tech:9000' + url
      } else if (host.includes('propub.com')) {
        url = 'https://www.imrpress.com' + url
      } else {
        url = 'http://192.168.5.18:3020' + url
      }
      window.open(url)
    },
    async exp() {
      this.loading = true
      try {
        const res = await statisticArticle.exportData(this.params)
        help.download(res.url, res.fileName)
      } catch (e) {
        this.loading = false
      }
      this.loading = false
    },
    onOrderChanage(val) {
      this.params.sorted = val
      this.getList()
    }
  }
}
